module.exports = __webpack_public_path__ + "static/img/biogramy01ok.58e4b41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontpage/biogramy01ok.jpg
// module id = byuN
// module chunks = 1